export default "__VITE_ASSET__c6aa2b0f__"